import '../StripCalendar.scss';
import { convertToDateObject } from '../../../helpers/dateHelpers';

const StripCalendarHolidayLabel = ({calendarElementWidth, dates, event, noData, key}) => {  

    const getEventMarginLeft = () => { 
        const startDate = convertToDateObject(event.start_date, "00:00");
        const startDayNumber = startDate.getDate();
        const startMonth = startDate.getMonth()+1;

        const startDateIndex = dates.findIndex(date => date.number === startDayNumber && date.month === startMonth);
        return startDateIndex * calendarElementWidth; 
    }

    return (
        <div className="c-strip-calendar-event" key={key}>
            {!noData?
            <div className="event--holiday" style={{width: calendarElementWidth+"%", marginLeft: `${getEventMarginLeft()}%`}}>
                <p className="event--holiday__lbl">{event.remarks}</p>
            </div>
            :""}
        </div>
    )
}

export default StripCalendarHolidayLabel;